import { mergeMap } from 'rxjs/operators'
import * as actions from './actions'
import { ofType } from 'redux-observable'
import { of, merge, Observable } from 'rxjs'
let Pusher = null
let pusherSocket

export const EVENT_STATES = {
  OPEN: 'open',
  CLOSED: 'closed',
}

const initPusher = (action$) => {
  return action$.pipe(
    ofType(actions.INIT_PUSHER),
    mergeMap((action) => {
      if (
        action &&
        action.payload &&
        action.payload.appCluster &&
        action.payload.appKey &&
        action.payload.Pusher
      ) {
        Pusher = action.payload.Pusher
        pusherSocket = new Pusher(action.payload.appKey, {
          cluster: action.payload.appCluster,
        })
      } else {
        return of({
          type: actions.INIT_PUSHER_REJECTED,
          payload: new Error('Valid appKey and appCluster required'),
        })
      }

      return of({
        type: actions.INIT_PUSHER_FULFILLED,
      })
    }),
  )
}

const subscribeToChannel = (action$) => {
  return action$.pipe(
    ofType(actions.SUBSCRIBE_TO_CHANNEL),
    mergeMap((action) => {
      if (action && action.payload && action.payload.channelId) {
        pusherSocket.subscribe(action.payload.channelId)
      } else {
        return of({
          type: actions.SUBSCRIBE_TO_CHANNEL_REJECTED,
          payload: new Error('Valid channelId required'),
        })
      }

      return of({
        type: actions.SUBSCRIBE_TO_CHANNEL_FULFILLED,
      })
    }),
  )
}

const unsubscribeFromChannel = (action$) => {
  return action$.pipe(
    ofType(actions.UNSUBSCRIBE_FROM_CHANNEL),
    mergeMap((action) => {
      if (action && action.payload && action.payload.channelId) {
        pusherSocket.subscribe(action.payload.channelId)
      } else {
        return of({
          type: actions.UNSUBSCRIBE_FROM_CHANNEL_REJECTED,
          payload: new Error('Valid channelId required'),
        })
      }

      return of({
        type: actions.UNSUBSCRIBE_FROM_CHANNEL_FULFILLED,
      })
    }),
  )
}

const bindToChannelEvent = (action$) => {
  return action$.pipe(
    ofType(actions.BIND_TO_CHANNEL_EVENT),
    mergeMap((action) => {
      if (
        action &&
        action.payload &&
        action.payload.channelId &&
        action.payload.eventId &&
        action.payload.dispatchAction
      ) {
        const channel = pusherSocket.subscribe(action.payload.channelId)
        return merge(
          Observable.create((observer) => {
            channel.bind(action.payload.eventId, (data, metaData) => {
              return observer.next({
                type: action.payload.dispatchAction,
                payload: {
                  data,
                  metaData,
                  channelId: action.payload.channelId,
                  eventId: action.payload.eventId,
                  delay: action.payload.delay,
                },
              })
            })
          }),
          of({
            type: actions.BIND_TO_CHANNEL_EVENT_FULFILLED,
            payload: {
              eventStates: {
                [action.payload.eventId]: EVENT_STATES.OPEN,
              },
            },
          }),
        )
      } else {
        return of({
          type: actions.BIND_TO_CHANNEL_EVENT_REJECTED,
          payload: new Error(
            'Valid channelId, eventId, and dispatchAction are required',
          ),
        })
      }
    }),
  )
}

const unbindFromChannelEvent = (action$) => {
  return action$.pipe(
    ofType(actions.UNBIND_FROM_CHANNEL_EVENT),
    mergeMap((action) => {
      if (
        action &&
        action.payload &&
        action.payload.channelId &&
        action.payload.eventId
      ) {
        const channel = pusherSocket.subscribe(action.payload.channelId)
        channel.unbind(action.payload.eventId)

        return of({
          type: actions.UNBIND_FROM_CHANNEL_EVENT_FULFILLED,
          payload: {
            eventStates: {
              [action.payload.eventId]: EVENT_STATES.CLOSED,
            },
          },
        })
      } else {
        return of({
          type: actions.UNBIND_FROM_CHANNEL_EVENT_REJECTED,
          payload: new Error('Valid channelId and eventId required'),
        })
      }
    }),
  )
}

export default {
  initPusher,
  subscribeToChannel,
  unsubscribeFromChannel,
  bindToChannelEvent,
  unbindFromChannelEvent,
}
